import React from "react";
import PropTypes from "prop-types";
import calendar from "../../assets/images/result_calendar.svg";
import { useMediaQuery } from "react-responsive";
import { logEvent } from "../../components/Analytics.js";
const VitaminB12 = ({
  bgColor = "#d4dce3",
  color,
  title,
  description,
  showLogo,
  isLogged,
  heading
}) => {
  const responsiveForInsights = useMediaQuery({ maxWidth: 767 });
  

  return (
    <div
      className={[
        "vitamin-b12-banner",
        "order-banner",
        responsiveForInsights ? "mt-3" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{ backgroundColor: bgColor }}
    >
      <div className="container-fluid banner-container">
        <div className="row align-items-center">
          <div className="col-12 banner-header ms-2">
            <h3>{heading}</h3>
            {responsiveForInsights && <h2
              className={`banner-title ${
                color === "light" ? "#003032" : "#003032"
              }`}
            >
              {title}
            </h2>}
          </div>
        </div>
        <div className="row align-items-center banner-content">
          <div className="vitamin-content">
            <div className="icon-col">
              <div className="product-image-wrapper">
                <img
                  src={calendar}
                  alt="Vitamin B12 Shot"
                  width={100}
                  height={100}
                  className={`product-image ${
                    showLogo ? "" : "calendar-image"
                  }`}
                />
              </div>
            </div>

            <div className="banner-col">
              <div
                className={`banner-text ${
                  color === "light" ? "text-teal" : "text-teal"
                } `}
              >
                <span className="service-description fs-24 ">
                  {description}
                </span>
              </div>
            </div>
          </div>

          <div className="btn-col">
            <button
              className="btn btn-white details-button"
              onClick={(e) => {
                const buttonCategory = showLogo ? "Find out more" : "Buy now";
                const buttonLabel = showLogo
                  ? "Find out more button"
                  : "Buy now button";
                if(isLogged === true){
                logEvent("button_click", {
                  category: buttonCategory,
                  action: "click",
                  label: buttonLabel,
                });
              }
                const url = showLogo
                  ? "https://www.boots.com/healthhub/a-z-services/vitamin-b12-service"
                  : "https://www.boots.com/boots-vitamin-b12-blood-test-kit-10362891";

                // Delay to allow GA event to trigger
                setTimeout(() => {
                  window.open(url, "_blank");
                }, 500);
              }}
            >
              {showLogo ? "Find out more" : "Buy now"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

VitaminB12.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.oneOf(["light", "dark"]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  showLogo: PropTypes.bool.isRequired,
  isLogged: PropTypes.bool.isRequired,
};

export default VitaminB12;
